import { ProjectSource } from '@/api/models/auth/lib/auth.types'
import {
  InvitePermissionOption,
  InvitePersonalAccount
} from '@/api/models/users/lib/invites.types'
import { AppCheckbox } from '@/components/shared/checkbox'

import { PremisePermissionsDropdown } from './PremisePermissionsDropdown'

type Props = {
  personalAccount: InvitePersonalAccount
  projectType: ProjectSource
  projectName: string
  isChecked: boolean
  isValid?: boolean
  selectedPermissions: InvitePermissionOption[]
  onSelect: (account: InvitePersonalAccount) => void
  onPermissionsChange: (
    accountId: string,
    permissions: InvitePermissionOption[]
  ) => void
}

export const PremisePicker = ({
  personalAccount,
  projectType,
  projectName,
  isChecked,
  isValid = true,
  selectedPermissions,
  onSelect,
  onPermissionsChange
}: Props) => {
  // У л/с может не быть помещений — такой аккаунт показываем как мультипомещение,
  // то есть по названию л/с, иначе обращение к premises[0] падает
  const isMultiPremise =
    projectType === ProjectSource.BU ||
    (projectType === ProjectSource.SC && personalAccount.premises.length !== 1)

  return (
    <div className="flex flex-col gap-8">
      <div className="flex items-start gap-12">
        <AppCheckbox
          className="mt-5"
          onChange={() => onSelect(personalAccount)}
          checked={isChecked}
          isValid={isValid}
        />
        <div className="flex flex-col">
          {isMultiPremise ? (
            <>
              <p className="text-20 xxs:text-16">{personalAccount.name}</p>
              <ul>
                {personalAccount.premises.map(({ id, name }) => (
                  <li
                    key={id}
                    className="ml-16 list-disc text-grey-60 text-14 xxs:text-12"
                  >
                    {name}
                  </li>
                ))}
              </ul>
            </>
          ) : (
            <p className="text-20 xxs:text-16">
              {personalAccount.premises[0].name}
            </p>
          )}
        </div>
      </div>
      {isChecked && (
        <PremisePermissionsDropdown
          premiseName={personalAccount.name}
          projectName={projectName}
          options={personalAccount.permissions}
          selected={selectedPermissions}
          onChange={selectedPermission =>
            onPermissionsChange(personalAccount.id, selectedPermission)
          }
        />
      )}
    </div>
  )
}
